import { isEmpty } from 'lodash';
import { useMemo } from 'react';

import { HealthProfessionalItemDataFragment } from '../../../data/types/api/graphql';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';
import { HealthProfessionalListItem } from './health-professional-list-item';

type HealthProfessionalListProps = {
  loading?: boolean;
  items: HealthProfessionalItemDataFragment[];
  onClick?: (value: HealthProfessionalItemDataFragment) => void;
};

export function HealthProfessionalList({
  loading = false,
  onClick,
  ...props
}: HealthProfessionalListProps) {
  const items = useMemo(() => props.items, [props.items]);

  if (loading) {
    return (
      <p>
        <CustomFormattedMessage id="common.loading" />
      </p>
    );
  }

  if (isEmpty(items)) {
    return (
      <p>
        <CustomFormattedMessage id="common.no-data" />
      </p>
    );
  }

  return (
    <div className="content-list">
      {items.map(option => (
        <div key={option.id} className="content-list__item">
          <HealthProfessionalListItem
            healthProfessional={option}
            onClick={onClick}
          />
        </div>
      ))}
    </div>
  );
}
